import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import {
  SETTLEMENT_TYPE,
  IDistributionType,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { IContractInputBaseProps } from '../base/ContractInputBase';

interface IContractInputDistributionSectionProps
  extends Omit<IContractInputBaseProps, 'name'> {
  distributionType: IDistributionType;
  settlementType?: SETTLEMENT_TYPE;
}

const ContractInputDistributionSection = ({
  id,
  distributionType,
  settlementType,
  ...props
}: IContractInputDistributionSectionProps) => {
  const { itemNameById, displayMode } = useFormikContractHelpers();

  const { t } = useTranslation();
  return (
    <Contract.Input.Base
      {...props}
      id={id}
      settlementType={settlementType}
      classNames={['contract-section-input']}
      name={`${itemNameById(id)}.content`}
      placeholder={t('input.placeholder.distribution', {type: t(`enum.TEMPLATE_TYPE.${TEMPLATE_TYPE[distributionType]}`)})}>
    </Contract.Input.Base>
  );
};

export default ContractInputDistributionSection;
